import { apiSlice } from "./apiSlice";

export const adminDataApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    landingPage: builder.query({
      query: () => ({
        url: "/getalllanding",
        method: "GET",
      }),
      keepUnusedDataFor: 5,
    }),
  }),
  overrideExisting: false,
});

export const { useLandingPageQuery } = adminDataApiSlice;
